export const interstitialAvailabilities = ['available', 'notAvailable'] as const

export type InterstitialAvailability = (typeof interstitialAvailabilities)[number]
